import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({ selector: '[windowScroll]' })
export class WindowScrollDirective {

  @Output() scrollValue = new EventEmitter<number>();

  @HostListener('window:scroll', ['$event']) onWindowScroll(event) {
    this.scrollValue.emit(((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100);
  }

  @HostListener('window:click', ['$event']) onWindowClick(event) {
    this.scrollValue.emit(((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100);
  }

}
